import React from "react";
import { PageTitle } from "../PageTitle";
import Masonry from "react-masonry-component";
import { REPORT_ROUTE_REMAP } from "../Main/component_paths";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const icons = {
    'summary-report-icon.svg': require("../../../public/images/icon/summary-report-icon.svg"),
    'single-report-icon.svg': require("../../../public/images/icon/single-report-icon.svg"),
    'download-report-icon.svg': require("../../../public/images/icon/download-report-icon.svg")
};

const MASONRY_OPTIONS = {
    itemSelector: ".masonry-item-4c",
    transitionDuration: 0,
    percentPosition: true,
    columnWidth: ".masonry-sizer-4c",
    gutter: ".gutter-sizer",
    stagger: 30
};

const styles = {
    card: {
        padding: 20,
        backgroundColor: "#fff",
        boxShadow: "1px 1px 5px 0px #00000028",
        width: "100%",
        height: "200px",
        gap: "10px",
        opacity: "0px",
        borderRadius: "5px",
        textAlign: "center"
    },
    icon: {
        paddingTop: 30,
        paddingBottom: 10
    },
    title: {
        fontWeight: 'bold',
    }
};

const ReportSectionContainer = ({ me, location }) => {
    const remap = REPORT_ROUTE_REMAP.find((remap) => remap.route.path === location.pathname);
    const allowedPaths = me.availableRoutes
                                .find((route) => route.path === "/reporting")?.children
                                .find((route) => route.path === location.pathname)?.children
                                .map((route) => route.path) ?? [];

    return (
        <div>
            <div className="row">
                <PageTitle title={`${remap.route.title} Reporting`} />
            </div>
            <div style={{padding: 30}}>
                <Masonry options={MASONRY_OPTIONS}>
                    <div className="masonry-sizer-4c" />
                    <div className="gutter-sizer" />
                    {Object.keys(remap.paths).sort((a, b) => a.localeCompare(b)).map((reportRoutePath) => {
                        const rewrittenRoute = reportRoutePath.replace("/reporting", remap.route.path);
                        return allowedPaths.includes(rewrittenRoute) && (
                            <div className="masonry-item-4c" key={`${reportRoutePath}`}>
                                <div style={styles.card}>
                                    <img style={styles.icon} src={icons[remap.paths[reportRoutePath].icon]} />

                                    <br />

                                    <Link to={rewrittenRoute}>
                                        <button className="btn btn-default">{remap.paths[reportRoutePath].title}</button>
                                    </Link>
                                </div>
                            </div>
                        )
                    })}
                </Masonry>
            </div>
        </div>
    );
}

export default connect((state) => ({ me: state.user.me }))(ReportSectionContainer);
